import { render, staticRenderFns } from "./PromotionGroupStat.vue?vue&type=template&id=bea89cae&scoped=true"
import script from "./PromotionGroupStat.vue?vue&type=script&lang=js"
export * from "./PromotionGroupStat.vue?vue&type=script&lang=js"
import style0 from "./PromotionGroupStat.vue?vue&type=style&index=0&id=bea89cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea89cae",
  null
  
)

export default component.exports